<template>
  <v-dialog v-model="filesDialog" width="500">
    <v-card>
      <v-tabs v-model="tab" color="#f9b418" fixed-tabs>
        <v-tab> Global Files </v-tab>
        <v-tab> Company Files </v-tab>
        <v-tab> My Files </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-list two-line>
              <v-list-item-group v-model="selected" active-class="orange--text">
                <template v-for="(file, index) in globalFiles">
                  <v-list-item>
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="file.name"
                        ></v-list-item-title>

                        <v-list-item-subtitle
                          v-text="file.mimetype"
                        ></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-action-text
                          v-text="file.type"
                        ></v-list-item-action-text>

                        <v-icon v-if="!active" color="grey lighten-1">
                          far fa-check-circle
                        </v-icon>

                        <v-icon v-else color="yellow darken-3">
                          fas fa-check-circle
                        </v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider inset></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-list two-line>
              <v-list-item-group
                v-model="selected"
                active-class="orange--text"
                multiple
              >
                <template v-for="(file, index) in companyFiles">
                  <v-list-item>
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="file.name"
                        ></v-list-item-title>

                        <v-list-item-subtitle
                          v-text="file.mimetype"
                        ></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-action-text
                          v-text="file.type"
                        ></v-list-item-action-text>

                        <v-icon v-if="!active" color="grey lighten-1">
                          far fa-check-circle
                        </v-icon>

                        <v-icon v-else color="yellow darken-3">
                          fas fa-check-circle
                        </v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider inset></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-list two-line>
              <v-list-item-group
                v-model="selected"
                active-class="orange--text"
                multiple
              >
                <template v-for="(file, index) in myFiles">
                  <v-list-item>
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="file.name"
                        ></v-list-item-title>

                        <v-list-item-subtitle
                          v-text="file.mimetype"
                        ></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-action-text
                          v-text="file.type"
                        ></v-list-item-action-text>

                        <v-icon v-if="!active" color="grey lighten-1">
                          far fa-check-circle
                        </v-icon>

                        <v-icon v-else color="yellow darken-3">
                          fas fa-check-circle
                        </v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider inset></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShowFiles',

  props: {
    filesDialog: Boolean,
    toggleFilesDialog: Function,
  },

  data: () => ({
    selected: null,
    tab: null,
    myFiles: [],
    companyFiles: [],
    globalFiles: [],
  }),

  mounted() {
    this.fetchMyFiles();
    this.fetchCompanyFiles();
    this.fetchGlobalFiles();
  },

  methods: {
    fetchMyFiles() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios.get('/client/lms/my-files').then(({ data }) => {
        this.myFiles = data;
      });
    },
    fetchCompanyFiles() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios.get('/client/lms/company-files').then(({ data }) => {
        this.companyFiles = data;
      });
    },
    fetchGlobalFiles() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios.get('/client/lms/global-files').then(({ data }) => {
        this.globalFiles = data;
      });
    },
  },
};
</script>

<style scoped></style>
